import { theme } from '@chakra-ui/react'

const FormLabel = {
  baseStyle: {
    m: 0,
  },
  sizes: {
    sm: {
      fontSize: theme.fontSizes.sm,
    },
  },
  variants: {},
  defaultProps: {},
}

export default FormLabel
